<template>
  <nav class="sticky top-0 z-50 bg-white dark:bg-gray-900 shadow-md border-b border-gray-200 dark:border-gray-700">
    <div class="max-w-7xl mx-auto px-6 lg:px-12">
      <div class="flex items-center justify-between h-16">
        <!-- Mobile Menu Button -->
        <div class="flex gap-2">
          <button @click="menuOpen = !menuOpen" class="md:hidden text-gray-700 dark:text-gray-200 focus:outline-none">
            <span class="material-icons text-2xl">{{ menuOpen ? 'close' : 'menu' }}</span>
          </button>
          <a href="#" class="flex items-center space-x-2">
            <span class="text-gray-600 dark:text-white material-symbols-outlined text-2xl">sword_rose</span>
            <span class="text-lg font-semibold text-gray-800 dark:text-gray-200">MHN</span>
          </a>

        </div>

        <div class="hidden md:flex space-x-6">
          <template v-for="(link, index) in navLinks" :key="index">
            <a
                :href="link.href"
                class="relative text-gray-700 dark:text-gray-200 hover:text-gray-900 dark:hover:text-white transition font-medium text-sm inline-block pb-1 group"
            >
              {{ link.text }}
              <span class="absolute left-0 bottom-0 w-full h-0.5 bg-blue-500 dark:bg-blue-400 origin-left transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 ease-in-out"></span>
            </a>
          </template>
        </div>

        <!-- Dark Mode Toggle -->
        <button
            @click="toggleDarkMode"
            class="w-10 h-10 flex items-center justify-center bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-100 rounded-full shadow-md hover:bg-gray-300 dark:hover:bg-gray-600 transition ml-4"
        >
          <span class="material-icons text-lg" v-if="!isDarkMode">light_mode</span>
          <span class="material-icons text-lg" v-else>dark_mode</span>
        </button>

      </div>

      <!-- Mobile Menu Dropdown -->
      <div v-if="menuOpen" class="md:hidden flex flex-col space-y-3 bg-white dark:bg-gray-800 shadow-lg rounded-md p-5 mb-1.5">
        <template v-for="(link, index) in navLinks" :key="index">
          <div class="relative">
            <a
                href="#"
                @click.prevent="scrollToSection(link.href)"
                class="relative text-gray-700 dark:text-gray-200 hover:text-gray-900 dark:hover:text-white transition font-medium text-sm pb-1 group"
            >
              {{ link.text }}
              <span class="absolute left-0 bottom-0 w-full h-0.5 bg-blue-500 dark:bg-blue-400 origin-left transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 ease-in-out"></span>
            </a>
          </div>
        </template>
      </div>

    </div>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      isDarkMode: false,
      menuOpen: false, // Controls the mobile menu
      navLinks: [
        { text: "About Me", href: "#about-me" },
        { text: "Experience", href: "#experience" },
        { text: "Expertise", href: "#expertise" },
        { text: "Projects", href: "#projects" },
        { text: "Contact", href: "#contact" },
      ],
    };
  },
  methods: {
    toggleDarkMode() {
      this.isDarkMode = !this.isDarkMode;
      document.documentElement.classList.toggle("dark", this.isDarkMode);
    },
    scrollToSection(id) {
      const target = document.querySelector(id);
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  },
};
</script>
